<div class="wrap">
  <app-header></app-header>
  <div class="main-holder">
    <app-nav></app-nav>
    <div class="main">
      <div class="main-content">
        <div class="bread">
          <ol>
            <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg" alt="Home"></a></li>
            <img src="../../../../assets/okito/images/icons/chevron-right.svg" alt="">
            <li><a [routerLink]="['/admin/taxi-fleet']">Taxi Fleet Management</a></li>
            <img src="../../../../assets/okito/images/icons/chevron-right.svg" alt="">
            <li><span>Enroll a Taxi Fleet Operator</span></li>
          </ol>
        </div>
        <div class="content-title">
          <h2>Enroll a Taxi Fleet Operator</h2>
        </div>
        <hr>

        <form class="enroll-form" (ngSubmit)="submitEnrollment(successModal, errorModal)">
          <div class="form-level-error" *ngIf="showFormLevelError">
            <i class="fa fa-exclamation-circle"></i> {{ formLevelErrorMessage }}
          </div>

          <div class="panel">
            <h3>Taxi Fleet Operator</h3>
            <div class="panel-info">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-item">
                    <label class="form-label">Fleet Type</label>
                    <select class="form-select" [(ngModel)]="form.fleetType" name="fleetType" (ngModelChange)="onFleetTypeChange()">
                      <option *ngFor="let option of fleetTypeOptions" [value]="option.value">{{ option.label }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('activeVehicles')">
                    <span class="error-required" *ngIf="hasFieldError('activeVehicles')">{{ fieldErrors.activeVehicles }}</span>
                    <label class="form-label">Number of allowed active vehicles</label>
                    <input type="text" class="form-control" inputmode="numeric" pattern="[0-9]*" maxlength="4" placeholder="Numeric only, up to 4 digits" [(ngModel)]="form.activeVehicles" name="activeVehicles" (input)="onActiveVehiclesInput($event)" required>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('operatorName')">
                    <span class="error-required" *ngIf="hasFieldError('operatorName')">{{ fieldErrors.operatorName }}</span>
                    <label class="form-label">Taxi Fleet Operator Name</label>
                    <p class="form-help">Fleet name to be displayed to Partners and Consumers</p>
                    <input type="text" class="form-control" maxlength="100" placeholder="Enter taxi fleet operator name" [(ngModel)]="form.operatorName" name="operatorName" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('registeredBusinessName')">
                    <span class="error-required" *ngIf="hasFieldError('registeredBusinessName')">{{ fieldErrors.registeredBusinessName }}</span>
                    <label class="form-label">Registered Business Name</label>
                    <p class="form-help">Legal registered name of taxi fleet operator</p>
                    <input type="text" class="form-control" maxlength="100" placeholder="Enter registered business name" [(ngModel)]="form.registeredBusinessName" name="registeredBusinessName" required>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel">
            <h3>Operator's Representative</h3>
            <div class="panel-info">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('repFirstName')">
                    <span class="error-required" *ngIf="hasFieldError('repFirstName')">{{ fieldErrors.repFirstName }}</span>
                    <label class="form-label">First Name</label>
                    <input type="text" class="form-control" maxlength="100" placeholder="Enter first name" [(ngModel)]="form.repFirstName" name="repFirstName" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('repLastName')">
                    <span class="error-required" *ngIf="hasFieldError('repLastName')">{{ fieldErrors.repLastName }}</span>
                    <label class="form-label">Last Name</label>
                    <input type="text" class="form-control" maxlength="100" placeholder="Enter last name" [(ngModel)]="form.repLastName" name="repLastName" required>
                  </div>
                </div>
              </div>
              <div class="form-item" [class.form-error]="hasFieldError('repEmail')">
                <span class="error-required" *ngIf="hasFieldError('repEmail')">{{ fieldErrors.repEmail }}</span>
                <label class="form-label">Email Address <span class="form-help">(Optional)</span></label>
                <p class="form-help">Optional. Can be completed by Fleet Operator Admin</p>
                <input type="email" class="form-control" placeholder="juan@gmail.com" [(ngModel)]="form.repEmail" name="repEmail">
              </div>
              <div class="form-item" [class.form-error]="hasFieldError('repMobile')">
                <span class="error-required" *ngIf="hasFieldError('repMobile')">{{ fieldErrors.repMobile }}</span>
                <label class="form-label">Mobile Number <span class="form-help">(Optional)</span></label>
                <p class="form-help">Optional. Can be completed by Fleet Operator Admin</p>
                <p class="form-help">Format: 09XXXXXXXXX/639XXXXXXXXX</p>
                <input type="tel" class="form-control" placeholder="09XXXXXXXXX / 639XXXXXXXXX" [(ngModel)]="form.repMobile" name="repMobile">
              </div>
              <div class="form-item" [class.form-error]="hasFieldError('validId')">
                <span class="error-required" *ngIf="hasFieldError('validId')">{{ fieldErrors.validId }}</span>
                <label class="form-label">Valid ID <span class="form-help">(Optional)</span></label>
                <p class="form-help">Optional. Can be completed by Fleet Operator Admin</p>
                <p class="form-help">Accepted files: jpeg, png, svg, img, pdf, doc</p>
                <div class="modal-upload-photo">
                  <input type="file" class="input-file" id="valid-id-file" accept=".jpeg,.jpg,.png,.svg,.img,.pdf,.doc" (change)="onValidIdChange($event)">
                  <div class="docs-holder">
                    <img src="../../../../assets/okito/images/docs.png" alt="">
                  </div>
                  <div class="btn-photo">
                    <label for="valid-id-file" class="btn btn-sm btn-outline">Upload File</label>
                  </div>
                </div>
                <div class="upload-thumb" *ngIf="showValidIdThumb">
                  <div class="upload-thumb-preview">
                    <img [src]="validIdPreviewUrl" alt="Uploaded file">
                  </div>
                  <span class="upload-thumb-name">{{ validIdFile?.name }}</span>
                  <button type="button" class="upload-thumb-remove" aria-label="Remove file" (click)="removeValidId()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="panel">
            <h3>Accreditation Details</h3>
            <div class="panel-info">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('ltfrbCpcNumber')">
                    <span class="error-required" *ngIf="hasFieldError('ltfrbCpcNumber')">{{ fieldErrors.ltfrbCpcNumber }}</span>
                    <label class="form-label">Valid LTFRB CPC Number</label>
                    <p class="form-help">Not applicable for TNVS fleets</p>
                    <input type="text" class="form-control" maxlength="100" placeholder="Enter LTFRB CPC number" [(ngModel)]="form.ltfrbCpcNumber" name="ltfrbCpcNumber" [disabled]="isCpcFieldsDisabled" [required]="!isCpcFieldsDisabled">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('cpcExpirationDate')">
                    <span class="error-required" *ngIf="hasFieldError('cpcExpirationDate')">{{ fieldErrors.cpcExpirationDate }}</span>
                    <label class="form-label">CPC Expiration Date</label>
                    <p class="form-help">Not applicable for TNVS fleets</p>
                    <input type="date" class="form-control" [(ngModel)]="form.cpcExpirationDate" name="cpcExpirationDate" [disabled]="isCpcFieldsDisabled" [required]="!isCpcFieldsDisabled">
                  </div>
                </div>
              </div>
              <!-- CPC document upload is fleet-side only -->
              <p class="form-help" *ngIf="requiresCpcDocument">
                Valid LTFRB CPC Document will be uploaded by the Fleet Operator Admin during enrollment.
              </p>
            </div>
          </div>

          <div class="panel">
            <h3>Admin Account Details <small>Details of the Admin account owner of the Taxi Fleet operator</small></h3>
            <div class="panel-info">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('adminFirstName')">
                    <span class="error-required" *ngIf="hasFieldError('adminFirstName')">{{ fieldErrors.adminFirstName }}</span>
                    <label class="form-label">Admin First Name</label>
                    <input type="text" class="form-control" maxlength="100" placeholder="Enter admin first name" [(ngModel)]="form.adminFirstName" name="adminFirstName" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('adminLastName')">
                    <span class="error-required" *ngIf="hasFieldError('adminLastName')">{{ fieldErrors.adminLastName }}</span>
                    <label class="form-label">Admin Last Name</label>
                    <input type="text" class="form-control" maxlength="100" placeholder="Enter admin last name" [(ngModel)]="form.adminLastName" name="adminLastName" required>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('adminEmail')">
                    <span class="error-required" *ngIf="hasFieldError('adminEmail')">{{ fieldErrors.adminEmail }}</span>
                    <label class="form-label">Email Address</label>
                    <p class="form-help">Email communication to Taxi Fleet Operator will be sent here.</p>
                    <input type="email" class="form-control" maxlength="100" placeholder="juan@gmail.com" [(ngModel)]="form.adminEmail" name="adminEmail" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-item" [class.form-error]="hasFieldError('adminMobile')">
                    <span class="error-required" *ngIf="hasFieldError('adminMobile')">{{ fieldErrors.adminMobile }}</span>
                    <label class="form-label">Mobile Number</label>
                    <p class="form-help">Unique mobile number. SMS communication to Taxi Fleet Operator will be sent here. Local PH number only.</p>
                    <input type="tel" class="form-control" placeholder="09XXXXXXXXX / 639XXXXXXXXX" [(ngModel)]="form.adminMobile" name="adminMobile" required>
                  </div>
                </div>
              </div>
              <!-- Role is display-only until CreateFleetAccountInput accepts it -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-item">
                    <label class="form-label">Role</label>
                    <select class="form-select" aria-label="Role" [(ngModel)]="form.adminRole" name="adminRole" disabled>
                      <option value="Admin">Admin</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="enroll-actions">
            <a [routerLink]="['/admin/taxi-fleet']" class="btn btn-sm btn-outline" [class.disabled]="isSubmitting">Cancel</a>
            <button type="submit" class="btn btn-sm btn-default" [disabled]="isSubmitting">
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              {{ isSubmitting ? 'Submitting...' : 'Submit Enrollment' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #successModal let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="closeSuccessModal()"></button>
  </div>
  <div class="modal-body success-body">
    <img src="../../../../assets/okito/images/modal-success.svg" alt="">
    <h4>Enrollment successful.</h4>
    <p>The Taxi Fleet Operator will receive their account credentials via their email. Remind them to verify their account.</p>
    <button type="button" class="btn btn-default" (click)="closeSuccessModal()">Close</button>
  </div>
</ng-template>

<ng-template #errorModal let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body error-body">
    <i class="fa fa-exclamation-circle"></i>
    <h4>Enrollment failed.</h4>
    <p>{{ errorMessage || 'Unable to complete enrollment. Please check the details and try again.' }}</p>
    <button type="button" class="btn btn-default" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>
